import { api } from '@/utils/api'

// 将获取ai歌词优化推荐的抽离成hook，方便复用
export const useGeneratePolishPromp = () => {
  const { mutateAsync, isLoading } =
    api.generation.generatePolishPrompt.useMutation({})

  return {
    mutateAsync,
    isLoading,
  }
}
